import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, useSlots } from 'vue';
  // const props = defineProps([ 'customClass' ]);
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  emits: ['changeTab'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const tabContainer = ref(null);
  const tabHeadersList = ref(null);
  const tabHeaders = ref(null);
  const tabs = ref(null);
  const activeTabIndex = ref(0);
  const slots = useSlots()
  const emit = __emit

  slots.default({
    changeTab: changeTab,
  })

  onMounted(() => {
    tabs.value = [ ...tabContainer.value.querySelectorAll('.tab') ];
    for(const x of tabs.value) {
      if(x.classList.contains('active')) {
        activeTabIndex.value = tabs.value.indexOf(x);
      }
    }

  })
  function changeTab (index, tab) {
    tabHeaders.value = [ ...tabHeadersList.value.querySelectorAll('.tab-header') ];
    activeTabIndex.value = index;
    for(const x of [...tabs.value, ...tabHeaders.value]) {
      x.classList.remove('active')
    }
    tabs.value[activeTabIndex.value].classList.add('active')
    tabHeaders.value[activeTabIndex.value].classList.add('active')
    emit('changeTab', tab.dataset.id)
  }

const __returned__ = { tabContainer, tabHeadersList, tabHeaders, tabs, activeTabIndex, slots, emit, changeTab, ref, onMounted, useSlots }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})